import {HTMLChakraProps, Table, chakra, useTableStyles} from "@chakra-ui/react";
import {ReactNode, createContext, forwardRef, useContext} from "react";
import {LinkProps, Link as RouterLink} from "react-router-dom";
import * as _ from "lodash-es";

const LinkContext = createContext<LinkProps | null>(null);

export function LinkProvider({children, ...linkProps}: {children?: ReactNode} & LinkProps) {
  return <LinkContext.Provider value={linkProps}>{children}</LinkContext.Provider>;
}

export const ContextualLink = forwardRef<HTMLAnchorElement, HTMLChakraProps<"a">>(({children, ...props}, ref) => {
  const linkProps = useContext(LinkContext);
  if (!linkProps) {
    throw new Error("ContextualLink must be used within a LinkProvider");
  }
  return (
    <chakra.a asChild {...props}>
      <RouterLink {...linkProps} ref={ref}>
        {children}
      </RouterLink>
    </chakra.a>
  );
});

export const CellLink = forwardRef<HTMLTableCellElement, HTMLChakraProps<"a">>(({children, ...props}, ref) => {
  const {cell} = useTableStyles();
  const padding = _.pick(cell, [
    "p",
    "padding",
    "pl",
    "paddingLeft",
    "pr",
    "paddingRight",
    "pt",
    "paddingTop",
    "pb",
    "paddingBottom",
    "ps",
    "paddingStart",
    "pe",
    "paddingEnd",
    "px",
    "paddingX",
    "py",
    "paddingY",
    "paddingInline",
    "paddingBlock",
  ]);
  return (
    <Table.Cell p="0 !important" ref={ref} h="full">
      <ContextualLink
        {...padding}
        className="cell-link"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="flex-start"
        h="full"
        {...props}
      >
        {children}
      </ContextualLink>
    </Table.Cell>
  );
});
